<li class="gw-action-item-label">
    <slot />
</li>

<style>
    .gw-action-item-label {
        border-top: 1px solid #f4f5f6;
        border-bottom: 1px solid #f4f5f6;
        padding: 8px;
        color: var(--gw-dark-text-color);
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
        appearance: none;
        font-style: normal;
        line-height: 20px;

        &:first-child {
            margin-top: 0;
            border-top: 0;
        }
    }
</style>
